// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  itemId: __t.u64(),
  name: __t.string(),
  description: __t.string(),
  priceCoins: __t.i64(),
  rarity: __t.string(),
  isAvailable: __t.bool(),
  isSeasonal: __t.bool(),
  previewAsset: __t.string(),
  assetData: __t.string(),
  availableFrom: __t.u64(),
  availableUntil: __t.u64(),
};
